<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2>{{ fileNamePrefix }}ユニット情報</h2>
      </div>
      <div class="input-area">
        <ul>
          <li>
            <span class="label">{{ fileNamePrefix }}ファイル名：</span>
            <input type="text" v-model="fileName" :placeholder="fileNamePrefix + 'ファイル名'">
            <div class="error_message" v-if="fieldErrorMessages.fileName">
              {{ fileNamePrefix + fieldErrorMessages.fileName }}
            </div>
          </li>
          <li>
            <span class="label">説明文：</span>
            <input type="text" v-model="fileCaption" placeholder="説明文">
          </li>
        </ul>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="onSubmit">{{ submitType }}</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL, KEY_CODE} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'

export default {
  name: 'NewModal',
  props: {
    /** 公開ユニットか */
    isOpen: Boolean,
    /** ファイルデータ(FileDataModel/OpenFileDataModel) */
    fileData: Object
  },
  computed: {
    submitType: function () {
      return this.isOpen ? '登録' : '公開'
    },
    fileNamePrefix: function () {
      return this.isOpen ? '' : '公開'
    }
  },
  data () {
    return {
      modalShown: false,
      fileName: '',
      fileCaption: '',
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        fileName: ''
      }
    }
  },
  watch: {
    modalShown: function () {
      if (this.modalShown) {
        document.addEventListener('keydown', this.onKeydown)
      } else {
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.fileName = (this.isOpen ? '' : '(公開) ') + this.fileData.fileName
      this.modalShown = true
    },
    /** モーダル非表示 */
    closeModal: function () {
      this.clearMessages()
      this.clearForm()
      this.modalShown = false
    },
    /** 登録/公開ボタン押下時 */
    onSubmit: function (event) {
      if (!this.modalShown) return
      event.preventDefault()
      this.clearMessages()
      document.removeEventListener('keydown', this.onKeydown)
      let messages = []
      // 公開済みの場合はアラート
      if (!this.isOpen && this.fileData.isPublishedAsOriginal) {
        messages.push(
          '既に公開済みのユニットデータです。',
          '再度公開すると公開中のユニットデータが上書きされます。'
        )
      }
      // 登録済みの場合はアラート
      if (this.isOpen && this.fileData.isRegistered) {
        messages.push(
          '既に登録済みのユニットデータです。',
          '再度登録するとご利用中のユニットデータが上書きされます。'
        )
      }
      messages.push('ユニットデータを' + this.submitType + 'します。', 'よろしいですか？')
      App.showModal({
        title: 'ユニット' + this.submitType,
        messages: messages,
        modalType: 'confirm',
        textAlign: 'left',
        onOk: this.registerUnitData,
        onCancel: () => { document.addEventListener('keydown', this.onKeydown) }
      })
    },
    /** キャンセルボタン押下時 */
    onCancel: function (event) {
      event.preventDefault()
      this.closeModal()
    },
    /** enter/escキー押下時 */
    onKeydown: function (event) {
      if (!event.ctrlKey && !event.shiftKey && !event.altKey && event.keyCode === KEY_CODE.ENTER) {
        this.onSubmit(event)
      } else if (event.keyCode === KEY_CODE.ESC) {
        this.onCancel(event)
      }
    },
    registerUnitData: function () {
      let payload = {
        fdId: this.fileData.fdId,
        fileName: this.fileName,
        fileCaption: this.fileCaption
      }
      axios.post(API_URL.UNIT + (this.isOpen ? '/register' : '/publish'), payload)
        .then(response => {
          if (response.data.errorMessage) {
            App.showModal({
              title: 'エラー',
              messages: [response.data.errorMessage],
              messageType: 'error'
            })
          } else {
            this.$emit('showDetail', false)
            App.showModal({
              messages: [this.submitType + 'しました。']
            })
          }
          this.closeModal()
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    clearForm: function () {
      this.fileName = ''
      this.fileCaption = ''
    },
    clearMessages: function () {
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        fileName: ''
      }
    }
  },
  created: function () {
  }
}
</script>

<style scoped>
.label {
  min-width: 120px;
  display: inline-block;
  text-align: right;
}
.error_message {
  margin-left: 130px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/unit/modal/RegisterModal.vue